import { ReactNode } from 'react';
import styles from './PageStage.module.css';

interface PageStageProps {
  children: ReactNode;
  /** Wider variant for chat (full-bleed reading column). */
  variant?: 'default' | 'wide' | 'narrow';
  className?: string;
}

export function PageStage({ children, variant = 'default', className }: PageStageProps) {
  const cls = [styles.stage, styles[variant], className].filter(Boolean).join(' ');
  return <main className={cls}>{children}</main>;
}
